import * as React from 'react';
import styled from 'styled-components';
import { PresentCard } from '../../components/03pushnotification/presentCardComponent';

type Props = {
    // imageUrl:string,
    // nftInfoName:string,
    // nftInfoDescription:string,
    // footerPragraph1:string,
    // footerPragraph2:string
}

export const PushNotificationPage: React.FC<Props> = (props) => {
  // background-color: #00001D;
  // background-image: url('https://nfttopshot-template.onrender.com/nandemolabostatic/img/top-bg.png');
  // overflow-x: hidden;
  const PushNotificationPageComponent = styled.main`
    text-align: center;
    color: white;
    background-repeat: no-repeat;
    background-size: 100% auto;
    font-family: 'Noto Sans JP',sans-serif;
    width: 100%;

    height: 100vh;
    justify-content: center;
  `;
    // height: 100%;
    // flex-wrap: wrap;
    // display: flex;

  return (
    //※中身を入れていかないと背景が表示されない 
    <PushNotificationPageComponent>
        <PresentCard/>
    </PushNotificationPageComponent>
  );
};